import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './Proyectos.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const PROYECTOS = [
  {
    id: 1,
    title: 'CAMPAMENTOS TEMPORALES TBM Y PLANTA CARRUSEL',
    image: '1 CAMPAMENTOS completo.svg',
  },
  {
    id: 2,
    title: 'CASO DE ÉXITO CON SIEMENS & MPSA',
    image: '2 CASO DE EXITO CON SIEMENS MPSA.svg',
  },
  {
    id: 3,
    title: 'PLANTA DE REBOMBEO DE AGUA RESIDUAL',
    image: '3 PLANTA DE REBOMBEO DE AGUA RESIDUAL.svg',
  },
  {
    id: 4,
    title: 'CASO DE ÉXITO CON SIEMENS & HPH JV – URIBE',
    image: '4-CASO-DE-EXITO-CON-SIEMENS-HPH-JV-URIBE.svg',
  },
  {
    id: 5,
    title: 'SIEMENS & SOLECTRIC-HITRAC-SPARKLE',
    image: '5 SIEMENS & SOLECTRIC-HITRAC-SPARKLE.svg',
  },
];

const Proyectos = () => {
  const backgroundImageUrl = `${PUBLIC_URL}/images/PROYECTOS_fondo.svg`;
  const backgroundStyle = {
    backgroundImage: `url("${backgroundImageUrl}")`,
  };

  return (
    <div className="proyectos-page">
      <div className="proyectos-background" style={backgroundStyle}></div>
      <Header />
      <div className="page-content">
        <h1>PROYECTOS EJECUTADOS</h1>
        <p className="proyectos-subtitle">Tecnología, energía y confianza en cada proyecto.</p>
        <p className="proyectos-description">
          Cada proyecto representa un reto técnico distinto y una oportunidad para desarrollar soluciones eléctricas confiables, eficientes y alineadas con las necesidades de cada entorno. Desde infraestructura pública hasta desarrollos privados, SOLETRIC participa en proyectos que exigen precisión, cumplimiento normativo y una ejecución técnica sólida.
        </p>
        <div className="proyectos-grid">
          {PROYECTOS.map((proyecto) => (
            <div key={proyecto.id} className="proyecto-card">
              <div className="proyecto-frame">
                <div className="proyecto-inner">
                  <div className="proyecto-image-wrap">
                    <img
                      src={`${PUBLIC_URL}/images/Proyectos/${encodeURIComponent(proyecto.image)}`}
                      alt={proyecto.title}
                      className="proyecto-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Proyectos;
